import React from 'react';

import http from 'api/http';
import { oilAPI } from 'api/requests';

import Pagination from 'Components/Pagination';
import RowsSelector from 'Components/RowsSelector';
import EmptyList from 'Components/EmptyList';
import FiltersSection from './FiltersSection';
import TableHeader from './TableHeader';
import Row from './Row';
import Store from '../../../../../registerIDBWorker';
import {Input, inputStyleClasses} from 'Components/Input';

const SEARCHABLE_FIELDS = ['name', 'number', 'formulaBaseOilNumber'];

export default class BrandList extends React.Component {
  defaultState = {
    activePage: 1,
    selectedRowsCount: 10,
    applicationStatus: 'All',
    selectedType: 'All',
    sortedBy: 'number',
    sortAsc: -1,
    filter: {},
    searchString: '',
  };

  constructor(props) {
    super(props);

    const storedState = props.user.getStoredState('brandListState', this.defaultState);
    props.user.updateURLSearchString(storedState);

    this.state = {
      ...this.defaultState,
      ...storedState,
    };

    this.listRequestInProgress = true;
    this.engineTypes = [];
    this.brandsList = [];
  }

  componentDidMount() {
    const { user } = this.props;

    http.get(oilAPI.engineTypes).then(({ data }) => {
      this.engineTypes = data;
      this.forceUpdate();
    });

    this._loadFromStore();

    this.handleSelectFilter('year')(user.getSelectedYear() || new Date().getFullYear());

    this.updateListData();
  }

  updateListData = () => {
    const { user } = this.props;
    const { filter } = this.state;

    http.get(oilAPI.brandsList(filter.brandSignStatus, filter.year)).then(({ data: list }) => {
      Store.insert(`${user.getActiveRole()}_lists`, list, user.getManufacturerCode()).then(() => {
        this.listRequestInProgress = false;
        this._loadFromStore();
      });
    });
  };

  _loadFromStore = () => {
    const { user } = this.props;

    Store.select(`${user.getActiveRole()}_lists`, user.getManufacturerCode()).then(list => {
      this.brandsList = list;
      this.forceUpdate();
    });
  };

  componentWillUnmount() {
    const { user } = this.props;

    user.saveState('brandListState', this.state, ['year']);
  }

  handleRowsSelect = (rowsCountSelected, totalRowsCount) => {
    const { user } = this.props;

    const selectedRowsCount = rowsCountSelected && rowsCountSelected < totalRowsCount ? rowsCountSelected : 0;

    const state = { selectedRowsCount, activePage: 1 };
    this.setState(state, user.updateURLSearchString(state));
  };

  handleActivePageChange = activePage => {
    const { user } = this.props;

    this.setState({ activePage }, () => {
      user.updateURLSearchString({ activePage });
    });
  };

  _filterList = componentList => {
    const { filter, searchString } = this.state;

    const doesSearchableFieldsContainSearchString = element => {
      for (let searchableFieldIndex in SEARCHABLE_FIELDS) {
        if (element[SEARCHABLE_FIELDS[searchableFieldIndex]]) {
          if (
            element[SEARCHABLE_FIELDS[searchableFieldIndex]]
              .toString()
              .toLowerCase()
              .includes(searchString.toLowerCase())
          )
            return true;
        }
      }
      return false;
    };

    return componentList.filter(element => {
      for (let filterFieldName in filter) {
        switch (filterFieldName) {
          case 'brandSignStatus':
            break;
          default:
            if (element[filterFieldName] !== filter[filterFieldName]) return false;
        }
      }
      return !searchString || doesSearchableFieldsContainSearchString(element);
    });
  };

  _sortList = (a, b) => {
    const { sortedBy, sortAsc } = this.state;

    switch (sortedBy) {
      case 'isPaid':
      case 'isReadAcrossFormula':
        return a[sortedBy] > b[sortedBy] ? sortAsc : -sortAsc;
      case 'year':
        return +a[sortedBy] > +b[sortedBy] ? sortAsc : -sortAsc;
      default:
        if (a[sortedBy] && b[sortedBy])
          return a[sortedBy].toString().toLowerCase().replace(/\s+/g, ' ') >
            b[sortedBy].toString().toLowerCase().replace(/\s+/g, ' ')
            ? sortAsc
            : -sortAsc;
        else return a[sortedBy] > b[sortedBy] ? sortAsc : -sortAsc;
    }
  };

  handleSort = sortedBy => () => {
    const { user } = this.props;

    this.setState(
      prevState => ({ sortedBy, sortAsc: -prevState.sortAsc, activePage: 1 }),
      () => {
        user.updateURLSearchString({ sortedBy: this.state.sortedBy, sortAsc: this.state.sortAsc, activePage: 1 });
      }
    );
  };

  handleSelectFilter = filterFieldName => filterElement => {
    const { user } = this.props;
    const selectedValue = filterElement.value !== undefined ? filterElement.value : filterElement;
    let newFilterState = this.state.filter;

    if (selectedValue === 'All') delete newFilterState[filterFieldName];
    else newFilterState[filterFieldName] = selectedValue;

    if (filterFieldName === 'year') {
      if (filterElement === 'All') {
        user.saveSelectedYear('');
      } else {
        user.saveSelectedYear(filterElement);
      }
    }

    this.setState({ filter: newFilterState, activePage: 1 }, () => {
      user.updateURLSearchString({ filter: this.state.filter, activePage: 1 });
      if (filterFieldName === 'brandSignStatus' || filterFieldName === 'year') this.updateListData();
    });
  };

  handleSearchStringInput = value => {
    const { user } = this.props;
    this.setState({ searchString: value, activePage: 1 }, () => {
      user.updateURLSearchString({ searchString: value });
    });
  };

  _getList = () => {
    const { activePage, selectedRowsCount, sortedBy } = this.state;
    const { user, createActionsList, selectAction } = this.props;

    let resultList = [];
    let resultLength = 0;

    if (!this.brandsList.length) {
      if (this.listRequestInProgress) {
        resultList = [
          <div key='no-spinner-div' className='ect-spinner _height_120'>
            <div className='ect-spinner__image' style={{ width: 50, height: 50 }} />
          </div>,
        ];
      } else {
        resultList = [<EmptyList key="empty">No brands for selected manufacturer.</EmptyList>];
      }
    } else {
      const filteredList = this._filterList(this.brandsList).sort(this._sortList);
      const sliceFrom = (activePage - 1) * selectedRowsCount;
      const sliceTo = +selectedRowsCount ? activePage * selectedRowsCount : filteredList.length;

      if (!filteredList.length) {
        resultList = [<EmptyList key="empty">No brands found with selected filters.</EmptyList>];
      } else {
        resultList = filteredList.slice(sliceFrom, sliceTo).map((brand, index) => {
          return (
            <Row
              key={brand.id}
              user={user}
              brand={brand}
              isOdd={!!(index % 2)}
              sortedBy={sortedBy}
              availableActionsList={createActionsList(brand)}
              selectAction={selectAction}
              updateListEntry={this.updateListEntry}
              deleteListEntry={this.deleteListEntry}
            />
          );
        });
        resultLength = filteredList.length;
      }
    }

    return {
      resultList,
      resultLength,
    };
  };

  updateListEntry = (oldEntry, newEntry) => {
    const { user } = this.props;

    let dataSource = newEntry.status ? newEntry : { ...oldEntry, status: newEntry };

    if (typeof newEntry === 'string') {
      oldEntry.status = newEntry;
    } else if (newEntry.year === oldEntry.year) {
      const oldEntryIndex = this.brandsList.indexOf(oldEntry);
      this.brandsList.splice(oldEntryIndex, 1, newEntry);
    } else {
      this.brandsList.push(newEntry);
    }

    Store.insert(`${user.getActiveRole()}_lists`, dataSource, user.getManufacturerCode());
  };

  deleteListEntry = oldEntry => {
    const { user } = this.props;

    const oldEntryIndex = this.brandsList.indexOf(oldEntry);
    this.brandsList.splice(oldEntryIndex, 1);
    Store.delete(`${user.getActiveRole()}_lists`, oldEntry);
  };

  render() {
    const { activePage, selectedRowsCount, sortedBy, sortAsc, filter, searchString } = this.state;
    const { resultList, resultLength } = this._getList();

    return (
      <section className='scene__scene-wrapper'>
        <section className='scene__content-wrapper list-scene__content-wrapper'>
          <header className='scene__scene-header list-scene__scene-header'>
            Brand List
            <Input
              mainWrapperClassName='list-scene__header-search-field-wrapper'
              styleClass={inputStyleClasses.searchBar}
              placeholder='Type here to search'
              maxLength={250}
              value={searchString}
              onChange={this.handleSearchStringInput}
            />
          </header>
          <FiltersSection
            outCount={resultLength}
            handleRowCountSelect={this.handleRowsSelect}
            rowsCount={selectedRowsCount}
            handleSelectFilter={this.handleSelectFilter}
            filterState={filter}
            engineTypes={this.engineTypes}
          />
          <TableHeader handleSortClick={this.handleSort} order={sortAsc === 1} sortedBy={sortedBy} />
          {resultList}
          <footer className='list-scene__footer'>
            <RowsSelector
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
              handleRowsSelect={this.handleRowsSelect}
            />
            <Pagination
              className='_height_80'
              activePage={activePage}
              handleClick={this.handleActivePageChange}
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
            />
          </footer>
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/List/index.jsx